import styled from "styled-components";

export const StyledKycVerificationViewWrapper = styled.div`
  border: 1px solid #f0f0f0;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.4rem;
  border-radius: 5px;
`;
export const StyledKycVerificationViewTextWrapper = styled.div`
  text-align: center;

  color: #1c1726;
  .title {
    font-size: 1.6rem;
    font-weight: 600;
  }
  .description {
    font-size: 1.4rem;
  }
`;
